import styled from 'styled-components/macro';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { textUpperCase } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const Heading = styled.div `
  ${getTextStyles('Play', 700, 18, 24)};
  ${textUpperCase};
  color: ${colorCoreWhite1000};

  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  word-break: break-word;
  padding-bottom: 16px;
`;
export const FooterStyled = styled.div `
  width: 100%;

  color: ${colorCoreWhite1000};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
